import { PayloadAction } from '@reduxjs/toolkit';
import { EDSV2ArrayResponse } from '@/types/eds/api/responses/EDSV2Response';
import { NormalizedV2Response } from '@/types/eds/api/responses/NormalizedV2Response';
import { HttpServiceResponse } from '@/services/HttpService/types';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  getPartyPaymentInformationData,
  getPartyPaymentInformationDataSuccess,
} from '@/features/drawer/components/PartyPaymentInformation/store/partyPaymentInformation.slice';
import { EdsDefinitionSections } from '@/features/eds/enums/EdsDefinitionSections';
import { EdsEntityCodes } from '@/features/eds/enums/EdsEntityCodes';
import EdsAdapterService from '@/features/eds/services/EdsAdapterService/EdsAdapterService';
import EdsDebugService from '@/features/eds/services/EdsDebugService/EdsDebugService';
import HttpService from '@/services/HttpService/HttpService';

function* getPartyPaymentInformationDataSaga({ payload }: PayloadAction<{ partyId: string }>) {
  try {
    const { data }: HttpServiceResponse<{ listings: EDSV2ArrayResponse }> = yield call(
      HttpService.post,
      `/filter/PaymentMethod?page=1&perPage=1000&includes=Address`,
      [
        {
          propertyName: 'PartyId',
          values: [payload.partyId],
        },
      ],
      {
        baseURL: import.meta.env.VITE_API_URL_EDS,
      },
    );

    const normalizedData: NormalizedV2Response[] = yield call(EdsAdapterService.normalize, data.listings, {
      section: EdsDefinitionSections.SidePanel,
    });

    EdsDebugService.logResponse(EdsEntityCodes.PaymentMethods, {
      rawResponse: data,
      normalizedResponse: normalizedData,
    });

    yield put(getPartyPaymentInformationDataSuccess({ partyPaymentInformationNormalizedData: normalizedData }));
  } catch (error) {
    console.error('Error fetching addresses data:', error);
  }
}

export function* partyPaymentInformationWatcher() {
  yield takeLatest([getPartyPaymentInformationData.type], getPartyPaymentInformationDataSaga);
}
